import { businessConfig, navigationLinks } from '../../../config/businessConfig';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div>
          <p className="site-footer__brand">{businessConfig.businessName}</p>
          <p className="site-footer__copy">Un espacio para potenciar tu belleza y regalarte un momento para ti.</p>
        </div>
        <nav aria-label="Enlaces del pie de página">
          <p className="site-footer__heading">Explorar</p>
          <ul>
            {navigationLinks.slice(1).map((link) => (
              <li key={link.id}><a href={`#${link.id}`}>{link.label}</a></li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="site-footer__heading">Conversemos</p>
          <a className="text-link" href={businessConfig.instagramUrl} target="_blank" rel="noreferrer">
            {businessConfig.instagramHandle} <span aria-hidden="true">↗</span>
          </a>
          <p className="site-footer__schedule">Lunes a sábado<br />{businessConfig.openingHours.mondayToSaturday}</p>
        </div>
      </div>
      <div className="container site-footer__bottom">
        <span>© {new Date().getFullYear()} {businessConfig.businessName}</span>
        <span>Atención personalizada por {businessConfig.founderName}</span>
      </div>
    </footer>
  );
}
